@let defaultField =
    kind === FormContainerKind.Text ||
    kind === FormContainerKind.Select ||
    kind === FormContainerKind.Date ||
    (kind === FormContainerKind.Chips && Scope.formControl.value.length === 0);
@let textAreaField = kind === FormContainerKind.TextArea;
@let checkBoxField = kind === FormContainerKind.Checkbox;
@let radioGroupField = kind === FormContainerKind.Radio;
@let froalaField = kind === FormContainerKind.Froala;
@let paypalField = kind === FormContainerKind.PayPal;
@let paypalStyleMatchField = kind === FormContainerKind.PayPalStyleMatch;
@let chipSelectField = kind === FormContainerKind.Chips && Scope.formControl.value.length > 0;
@let hasBorder = defaultField || textAreaField || chipSelectField || froalaField || paypalStyleMatchField || paypalField;
@let hasTextFieldFooter = hasBorder || kind === FormContainerKind.SubForm;
@let switchField = kind === FormContainerKind.Switch;
@let segmentedButtonField = kind === FormContainerKind.SegmentedButton;
<div
    class="d-flex"
    [ngClass]="{
        'flex-column': !switchField,
        'sb-form-field-container-switch': switchField
    }">
    <ng-container *ngTemplateOutlet="label; context: { $implicit: hasTextFieldFooter }"></ng-container>

    @if (Scope.isReadOnly) {
        <ng-content select="[readOnly]"></ng-content>
    } @else {
        <div
            class="sb-form-field-input-row"
            [ngClass]="{ 'sb-form-field-view-only': Scope.isViewOnly }">
            <div
                #oPrefix
                [hidden]="!oPrefix.textContent">
                <ng-container *ngTemplateOutlet="outsidePrefix"></ng-container>
            </div>

            @if (!checkBoxField && !radioGroupField && !switchField) {
                <div
                    [hidden]="!Scope.isLoading"
                    [style.height]="loadingHeight"
                    [style.min-height]="loadingHeight"
                    [ngClass]="{
                        'sb-form-field-border-loading': !segmentedButtonField,
                        'sb-form-field-loading': !Scope.isReadOnly && !textAreaField && !froalaField && !segmentedButtonField,
                        'sb-form-field-text-area-loading': !Scope.isReadOnly && (textAreaField || froalaField),
                        'sb-form-field-segmented-button-loading': !Scope.isReadOnly && segmentedButtonField,
                        'sb-form-field-loading-read-only': Scope.isReadOnly && !segmentedButtonField
                    }"></div>
            }

            <div
                [attr.data-sb-qa]="Scope.qaTag ? Scope.qaTag + '-form-field-container-div' : ''"
                [matMenuTriggerFor]="Scope.isDisabled ? null : matMenu"
                matAutocompleteOrigin
                #origin="matAutocompleteOrigin"
                panelTrigger
                [hidden]="Scope.isLoading && !checkBoxField && !radioGroupField && !switchField"
                class="w-100"
                [ngClass]="{
                    'sb-form-field-froala-container': froalaField,
                    'sb-form-field': !Scope.isDisabled && defaultField && !hasError,
                    'sb-form-field-text-area': !Scope.isDisabled && textAreaField,
                    'sb-form-field-froala': !Scope.isDisabled && froalaField && !hasError,
                    'sb-form-field-chip-select': !Scope.isDisabled && chipSelectField && !hasError && Scope.formControl.value.length,
                    'sb-form-field-disabled': Scope.isDisabled && hasBorder && !paypalField,
                    'sb-form-field-error': hasError && hasBorder && !textAreaField && !paypalStyleMatchField && !paypalField,
                    'sb-form-field-text-area-error': hasError && textAreaField && !Scope.isDisabled,
                    'sb-form-field-checkbox-error': hasError && checkBoxField,
                    'sb-form-field-border': hasBorder && kind !== FormContainerKind.Legacy && !paypalStyleMatchField && !paypalField,
                    'justify-content-between': hasBorder,
                    'sb-form-field-paypal': paypalField && !Scope.isDisabled,
                    'sb-form-field-paypal-disabled': paypalField && Scope.isDisabled,
                    'sb-form-field-paypal-stylematch': paypalStyleMatchField && !Scope.isDisabled && !hasError,
                    'sb-form-field-paypal-stylematch-disabled': paypalStyleMatchField && Scope.isDisabled,
                    'sb-form-field-paypal-stylematch-error': paypalStyleMatchField && hasError,
                    'sb-form-field-paypal-stylematch-border': paypalStyleMatchField && hasBorder
                }"
                tabindex="-1"
                (focusin)="Focus()"
                (focusout)="FocusOut()"
                (click)="fieldClicked.emit($event)"
                (touchstart)="fieldTouched.emit($event)">
                <div
                    [ngClass]="{
                        'sb-form-field-text-wrapper': !chipSelectField,
                        'sb-form-field-text-wrapper-chip-select': chipSelectField
                    }">
                    <ng-container *ngTemplateOutlet="prefix"></ng-container>
                    <ng-container *ngTemplateOutlet="input"></ng-container>
                    <ng-container *ngTemplateOutlet="suffix"></ng-container>
                </div>
            </div>

            <div
                #oSuffix
                [hidden]="!oSuffix.textContent">
                @if (Scope.formControl.isAutofilled) {
                    <ng-container *ngTemplateOutlet="autofill"></ng-container>
                } @else {
                    <ng-container *ngTemplateOutlet="outsideSuffix"></ng-container>
                }
            </div>
        </div>
        @if (hasTextFieldFooter) {
            <div #footerContainer>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: hasTextFieldFooter }"></ng-container>
            </div>
        }

        @if(Scope.isDisabled && kind === FormContainerKind.PayPal) {
            <!-- eslint-disable-next-line -->
            <div class="sb-form-field-paypal-disabled-masked">••••••••••••••</div>
        }
    }
</div>

<ng-template
    #label
    let-hasBorder>
    <div
        class="d-flex align-items-center justify-content-between"
        (click)="containerClicked.emit($event)">
        <div class="d-flex flex-column">
            <lib-label
                [hidden]="!label.textContent"
                [formFieldID]="Scope.formFieldID"
                [isRequired]="Scope.showRequiredIndicator ?? Scope.formControl.isRequired"
                [isDisabled]="Scope.formControl.disabled"
                [kind]="kind"
                [isReadonly]="Scope.isReadOnly">
                <span #label>
                    <ng-content select="[label]"></ng-content>
                </span>
                <ng-container helper>
                    <ng-container *ngTemplateOutlet="helper"></ng-container>
                </ng-container>
            </lib-label>
            @if (!hasBorder && !Scope.isReadOnly) {
                <ng-container *ngTemplateOutlet="footer; context: { $implicit: hasBorder }"></ng-container>
            }
        </div>
        <!-- Quick Select is deprecated and will go away eventually -->

        <ng-container *ngTemplateOutlet="menu"></ng-container>
    </div>
</ng-template>

<ng-template
    #footer
    let-hasBorder>
    <div [class.sb-form-field-footer]="hasBorder">
        <ng-container *ngTemplateOutlet="supportingText; context: { $implicit: hasTextFieldFooter }"></ng-container>
        @if (!hasError) {
            <!-- Bottom Menu is deprecated and will go away eventually -->
            <ng-container *ngTemplateOutlet="bottomMenu"></ng-container>
        }
        <div [id]="Scope.formFieldID + '-error'">
            @if (hasError) {
                <lib-error
                    [qaTag]="Scope.qaTag ? Scope.qaTag + '-form-field-container-error' : ''"
                    [control]="Scope.formControl"
                    [errors]="Scope.errors"></lib-error>
            }
        </div>
    </div>
</ng-template>

<ng-template
    #supportingText
    let-hasBorder>
    <div
        #stContent
        [hidden]="!Scope.isLoading && !stContent.textContent"
        [id]="Scope.formFieldID + '-description'"
        [style.display]="hasError ? 'none' : null"
        [ngClass]="{ 'sb-form-field-supporting-text-no-border': !hasBorder && !Scope.isLoading, 'sb-form-field-supporting-text': hasBorder && !Scope.isLoading }">
        @if (Scope.isLoading) {
            <div
                #supportingTextContent
                hidden>
                <ng-container *ngTemplateOutlet="supportingTextTemplate"></ng-container>
            </div>
            @if (supportingTextContent.textContent) {
                <div class="sb-form-field-text-skeleton sb-form-field-text-skeleton-sm"></div>
            }
        } @else {
            <lib-supporting-text>
                <ng-container *ngTemplateOutlet="supportingTextTemplate"></ng-container>
            </lib-supporting-text>
        }
    </div>
</ng-template>

<ng-template #supportingTextTemplate>
    <ng-content select="[supportingText]"></ng-content>
</ng-template>

<ng-template #prefix>
    <div
        #prefixWrapper
        class="sb-form-field-prefix"
        [class.sb-form-field-prefix-icon-button]="Scope.hasPrefixIconButton"
        [hidden]="!prefixWrapper.textContent">
        <ng-content select="[prefixIcon]"></ng-content>
        <p
            class="text-nowrap"
            #content
            [hidden]="!content.textContent">
            <ng-content select="[prefixText]"></ng-content>
        </p>
    </div>
</ng-template>

<ng-template #suffix>
    <div
        #suffixWrapper
        class="sb-form-field-suffix"
        [class.sb-form-field-suffix-icon-button]="Scope.hasSuffixIconButton"
        [hidden]="!suffixWrapper.textContent">
        <p
            class="text-nowrap"
            #content
            [hidden]="!content.textContent">
            <ng-content select="[suffixText]"></ng-content>
        </p>
        <ng-content select="[suffixIcon]"></ng-content>
    </div>
</ng-template>

<ng-template #input>
    <ng-content></ng-content>
</ng-template>

<ng-template #outsidePrefix>
    <div
        class="text-nowrap"
        #prefixContent
        [hidden]="!prefixContent.hasChildNodes()">
        <ng-content select="[outsidePrefix]"></ng-content>
    </div>
</ng-template>

<ng-template #outsideSuffix>
    <div
        class="text-nowrap"
        #suffixContent
        [hidden]="!suffixContent.hasChildNodes()">
        <ng-content select="[outsideSuffix]"></ng-content>
    </div>
</ng-template>

<ng-template #autofill>
    @if (Scope.formControl.isAutofilled) {
        <lib-icon
            [icon]="Icon.Common.AutoAwesome"
            [size]="IconSize.Small"></lib-icon>
    }
</ng-template>

<ng-template #helper>
    @if (Scope.popoverTemplate) {
        <div
            #popoverTarget
            class="sb-form-field-helper">
            <lib-icon
                [icon]="Icon.Common.HelpOutline"
                [size]="IconSize.TwoExtraSmall"
                (click)="HelperClicked($event)"></lib-icon>
        </div>
        <ng-container *ngTemplateOutlet="Scope.popoverTemplate; context: { $implicit: popoverTarget }"></ng-container>
    }
</ng-template>

<ng-template #bottomMenu>
    <div
        #bmContent
        [hidden]="!bmContent.textContent">
        <ng-content
            bottomMenu
            select="[bottomMenu]"></ng-content>
    </div>
</ng-template>

<ng-template #menu>
    <div
        #menuContent
        [hidden]="!menuContent.textContent"
        class="padding-bottom-4">
        <ng-content
            menu
            select="[menu]"></ng-content>
    </div>
</ng-template>
